import { useLayoutEffect, useState } from "react";

import { BrandLoadingScreen } from "@/components/Layout/BrandLoadingScreen/BrandLoadingScreen";

/**
 * Shown briefly on first app load, then fades out to reveal routed content.
 */
export const SplashScreens = () => {
  const [showTransition, setShowTransition] = useState(false);

  useLayoutEffect(() => {
    setShowTransition(true);
    const timeoutID = window.setTimeout(() => {
      setShowTransition(false);
    }, 2500);

    return () => window.clearTimeout(timeoutID);
  }, []);

  if (!showTransition) {
    return null;
  }

  return <BrandLoadingScreen dataTestId="app-splash-screen" />;
};
